import React, { useState, useEffect } from "react"
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  Button,
  Modal,
  ModalHeader
} from "reactstrap"
import BootstrapTable from 'react-bootstrap-table-next'
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit'
import paginationFactory from 'react-bootstrap-table2-paginator'
import rest from '../../../lib/rest'
import rotas from '../../../services/rotas'
import FormFavorecido from "./formFavorecido"
import useToggle from "../../../lib/useToggle"
import Loading from 'lib/loading'

const Favorecidos = ()=> {

  const colunas = [
    {
      dataField: 'favorecido_id',
      text: 'Código'
    },
    {
      dataField: 'favorecido',
      text: 'Favorecido'
    },
    {
      dataField: 'favorecido_documento',
      text: 'Documento'
    }
  ]

  const { SearchBar }                         = Search
  const [loading, setLoading]                 = useState(true)
  const [modal, setModal]                     = useToggle()
  const [favorecido_id, setFavorecido_id]     = useState('')
  const [listaFavorecido, setListaFavorecido] = useState([])

  const listaFavorecidos = () => {
    let lista = []
    const url = rotas.favorecido
    try{
      const retorno = rest.get(url)
      retorno.then(ret => {
        if (ret !== '' && ret.success && ret.success === 'S'){
          lista = ret.lista
          setListaFavorecido(lista)
        }else{
          setListaFavorecido([])
        }
        setLoading(false)
      })
      return (lista)

    }catch(err){

    }
  }

  useEffect(() => {
    const load = loading
    if (load === true) {
      listaFavorecidos()
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if(modal === false){
      listaFavorecidos()
    }
  }, [modal]) // eslint-disable-line react-hooks/exhaustive-deps

  //abrir modal do formulario
  const abreModal = (favorecido_id) => {
    setFavorecido_id(favorecido_id)
    setModal()
  }

  if (loading) {
    return (
      <Loading
        tipo='paginas'
      />
    )
  }else {
    return (
      <div className="content">
        <Container>
          <Row>
            <Col md="12" className="p-0">
              <Card>
                <CardHeader>
                  <CardTitle>CADASTRO DE FAVORECIDOS</CardTitle>
                </CardHeader>
                <CardBody>
                  <Modal
                    size   = 'xl'
                    isOpen = {modal}
                  >
                    <ModalHeader>Cadastro de Favorecidos</ModalHeader>
                    <FormFavorecido
                      favorecido_id = {favorecido_id}
                      fechaModal    = {setModal}
                    ></FormFavorecido>
                  </Modal>
                  <ToolkitProvider
                    keyField  = "favorecido_id"
                    data      = {listaFavorecido}
                    columns   = {colunas}
                    search
                  >
                    {
                      props => (
                        <div>
                          <Container>
                            <Row>
                              <Col md="3">
                                <Button
                                  className = "m-0 w-100"
                                  color     = "primary"
                                  style     = {{ padding: '5px 20px' }}
                                  onClick   = {() => abreModal('')}
                                  outline
                                >
                                  <i className="fas fa-plus" />
                                  Cadastrar
                                </Button>
                              </Col>

                              <Col md="9">
                                <SearchBar
                                  placeholder = "Buscar Favorecido..."
                                  style       = {{ padding: '5px' }}
                                  {...props.searchProps}
                                />
                              </Col>
                            </Row>
                          </Container>

                          <hr/>

                          <BootstrapTable
                            striped
                            keyField         = 'favorecido_id'
                            noDataIndication = "Nenhum registro encontrado"
                            rowStyle         = {{ cursor: "pointer" }}
                            pagination       = {paginationFactory({
                                                sizePerPage: 10,
                                                hideSizePerPage: true,
                                                hidePageListOnlyOnePage: true,
                                                showTotal: false,
                                                })}
                            rowEvents        = {{
                                                  onDoubleClick: (e, row, rowIndex) => {
                                                    abreModal(row.favorecido_id)
                                                  }
                                                }}
                            {...props.baseProps}
                          />
                          <br />
                        </div>
                      )
                    }
                  </ToolkitProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

export default Favorecidos;